import { useQuery } from "@apollo/client";
import React from "react";
import { ORGANISATIONAL_UNITS_QUERY } from "../../../graphql/query";

import styles from "./practice-area-container.css";
import { FindOrganisationalUnits } from "../../../graphql/__generated_types__/FindOrganisationalUnits";
import { PracticeAreaSettingsPage } from "./practice-area-settings-page";
import { Spin } from "antd";

const { ["container"]: containerClassName } = styles as any;

export const PracticeAreaSettingsContainer = () => {
  const { data: practiceAreas, loading } = useQuery<FindOrganisationalUnits>(
    ORGANISATIONAL_UNITS_QUERY
  );

  return (
    <div className={containerClassName}>
      {loading ? (
        <Spin size="large" />
      ) : (
        <PracticeAreaSettingsPage
          practiceAreas={practiceAreas?.organisationalUnits || []}
          loading={loading}
          onChange={() => {}}
        ></PracticeAreaSettingsPage>
      )}
    </div>
  );
};
